export default __webpack_public_path__ + "static/media/04.753de15f.jpg";